export default __webpack_public_path__ + "static/media/ILPlatform_Project.420de28e.webp";